const CACHE_HEADER_BASE = "x-cache-layer";
/** Whether this request should use the cache layer provided by the shell */
export const CACHE_HEADER_ENABLED = `${CACHE_HEADER_BASE}-enabled`;
/** Defines the time for the request to be considered "fresh" and not be refetched, default: Infinity */
export const CACHE_HEADER_STALE_TIME = `${CACHE_HEADER_BASE}-stale-time`;
/** Forces an update of the cached value, calls every event listener  */
export const CACHE_HEADER_RELOAD = `${CACHE_HEADER_BASE}-reload`;
